import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import Logo from '../components/Logo';
import { Home, ArrowLeft } from 'lucide-react';

const NotFound = () => {
    return (
        <div className="not-found-page">
            <div className="container">
                <motion.div
                    className="not-found-content"
                    initial={{ opacity: 0, y: 30 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8 }}
                >
                    <Logo size="large" />

                    <div className="error-code">404</div>

                    <h1>Page Not Found</h1>

                    <p>
                        The page you're looking for doesn't exist or has been moved.
                        Please check the URL or return to the homepage.
                    </p>

                    <div className="action-buttons">
                        <Link to="/" className="btn btn-primary">
                            <Home size={20} />
                            Go Home
                        </Link>
                        <button
                            className="btn btn-secondary"
                            onClick={() => window.history.back()}
                        >
                            <ArrowLeft size={20} />
                            Go Back
                        </button>
                    </div>
                </motion.div>
            </div>

            <style jsx>{`
        .not-found-page {
          min-height: 100vh;
          display: flex;
          align-items: center;
          justify-content: center;
          background: linear-gradient(135deg, var(--primary-bg) 0%, #d6e7ff 100%);
          padding: 20px;
        }

        .not-found-content {
          text-align: center;
          max-width: 500px;
          width: 100%;
        }

        .error-code {
          font-size: 120px;
          font-weight: 900;
          color: var(--primary-accent);
          line-height: 1;
          margin: 32px 0 24px 0;
          text-shadow: 0 4px 8px rgba(0, 89, 255, 0.2);
        }

        .not-found-content h1 {
          font-size: 36px;
          font-weight: 700;
          color: var(--text-primary);
          margin-bottom: 16px;
        }

        .not-found-content p {
          font-size: 18px;
          color: var(--text-secondary);
          line-height: 1.6;
          margin-bottom: 40px;
        }

        .action-buttons {
          display: flex;
          gap: 16px;
          justify-content: center;
          flex-wrap: wrap;
        }

        @media (max-width: 480px) {
          .error-code {
            font-size: 80px;
          }

          .not-found-content h1 {
            font-size: 28px;
          }

          .not-found-content p {
            font-size: 16px;
          }

          .action-buttons {
            flex-direction: column;
            align-items: center;
          }

          .action-buttons .btn {
            width: 100%;
            max-width: 200px;
          }
        }
      `}</style>
        </div>
    );
};

export default NotFound;

